import { Box } from "@chakra-ui/react"
import {
  CoverPageOfferFragment,
  ShareAccessPermission
} from "@pathwright/graphql-client/src/generated"
import { useCallback, useRef, useState } from "react"
import { ShareDumb } from "../share/Share"
import { CoverPageSectionEditTriggerButton } from "./design/CoverPageSectionTrigger"
import { useCoverPageTranslate } from "./utils"

export function canShareCoverPageOffer(offer: CoverPageOfferFragment) {
  return (
    !!offer.cohort_id &&
    !!offer.share_access &&
    (offer.share_access.access === ShareAccessPermission.Full ||
      offer.share_access.access === ShareAccessPermission.Gated)
  )
}

export default function CoverPageOfferShare({
  offer
}: {
  offer: CoverPageOfferFragment
}) {
  // This is a lazy-mount latch, not dialog open state. Share owns its disclosure
  // after activation; retaining it on close preserves focus return and reopening.
  const [hasOpened, setHasOpened] = useState(false)
  const trigger = useRef<HTMLDivElement>(null)
  const { t } = useCoverPageTranslate()
  const finalFocusEl = useCallback(
    () => trigger.current?.querySelector("button") || null,
    []
  )
  const renderButton = (onClick: () => void) => (
    <CoverPageSectionEditTriggerButton
      label={null}
      icon="share-fill"
      ariaLabel={t("offer.share", {
        defaultValue: "Share {{name}}",
        name: offer.title
      })}
      onClick={onClick}
    />
  )
  if (!canShareCoverPageOffer(offer)) return null
  return (
    <Box ref={trigger}>
      {hasOpened ? (
        <ShareDumb
          context={{ type: "cohort", typeId: offer.cohort_id }}
          placement={null}
          triggerLabel={null}
          triggerIcon={null}
          portal={false}
          defaultOpen
          openWithQueryParam={false}
          openWithKeys={false}
          displayType="modal"
          hideTabs={false}
          onToggleIsOpen={null}
          finalFocusEl={finalFocusEl}
        >
          {({
            renderTrigger
          }: {
            renderTrigger: (
              Trigger: React.ComponentType<{ onToggle: () => void }>
            ) => React.ReactNode
          }) => renderTrigger(({ onToggle }) => renderButton(onToggle))}
        </ShareDumb>
      ) : (
        renderButton(() => setHasOpened(true))
      )}
    </Box>
  )
}
